import React from 'react';
import styled from 'styled-components';

var InvisibleButton = styled.button.withConfig({
  displayName: "ModalCloseButton__InvisibleButton",
  componentId: "sc-6uc3g6-0"
})(["vertical-align:middle;box-shadow:none;padding:0px;border:0px none;background-color:transparent;margin:0;"]);
var iconStyle = {
  borderRadius: '50%',
  cursor: 'pointer'
};

var ModalCloseButton = function ModalCloseButton(_ref) {
  var onClick = _ref.onClick,
      style = _ref.style,
      variant = _ref.variant;
  return React.createElement(InvisibleButton, {
    style: style,
    onClick: onClick,
    "aria-label": "close"
  }, React.createElement("svg", {
    style: iconStyle,
    width: variant === 'kiosk' ? '48px' : '32px',
    height: variant === 'kiosk' ? '48px' : '32px',
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, React.createElement("circle", {
    fill: "#333",
    cx: "12",
    cy: "12",
    r: "11"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M12 10.586l4.243-4.243 1.414 1.414L13.414 12l4.243 4.243-1.414 1.414L12 13.414l-4.243 4.243-1.414-1.414L10.586 12 6.343 7.757l1.414-1.414z"
  }))));
};

ModalCloseButton.displayName = 'ModalCloseButton';

export default ModalCloseButton;
